var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1312_21)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1312_21)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8281 12C23.8281 5.37258 18.4555 0 11.8281 0C5.2007 0 -0.171875 5.37258 -0.171875 12C-0.171875 17.9895 4.21633 22.954 9.95312 23.8542V15.4687H6.90625V12H9.95312V9.35625C9.95312 6.34875 11.7447 4.6875 14.4857 4.6875C15.7987 4.6875 17.1719 4.92187 17.1719 4.92187V7.875H15.6588C14.1681 7.875 13.7031 8.80008 13.7031 9.74906V12H17.0312L16.4992 15.4687H13.7031V23.8542C19.4399 22.954 23.8281 17.9895 23.8281 12Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4992 15.4688L17.0312 12H13.7031V9.74906C13.7031 8.80008 14.1681 7.875 15.6587 7.875H17.1719V4.92188C17.1719 4.92188 15.7987 4.6875 14.4857 4.6875C11.7447 4.6875 9.95312 6.34875 9.95312 9.35625V12H6.90625V15.4688H9.95312V23.8542C10.5641 23.9501 11.1902 24 11.8281 24C12.4661 24 13.0921 23.9501 13.7031 23.8542V15.4688H16.4992Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1312_21"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1312_21"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(-0.171875)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.e08ddcf1f7ae7e2df9d0d2c052023006.svg";
export { ForwardRef as ReactComponent };